import { CopyIcon } from '../../../assets/svgIcons/svgIcons';
// import CustomPagination from "../../../components/common/CustomPagination/CustomPagination";
import CommonTable from '../../../components/common/CustomTable/CommonTable';

const StakingInProgressTable = () => {
  const fields = [
    'Data & Time',
    'Order ID',
    'Amount',
    'Transaction Type',
    'Status',
  ];
  const list = [
    {
      date: '10/12/2024 16:46:47',
      order: '0x47685...4c8B',
      amount: '$0.01',
      transaction: 'Stake',
      status: 'Pending',
    },
    {
      date: '10/12/2024 16:46:47',
      order: '0x47685...4c8B',
      amount: '$0.01',
      transaction: 'Unstake',
      status: 'Pending',
    },
    {
      date: '10/12/2024 16:46:47',
      order: '0x47685...4c8B',
      amount: '$0.01',
      transaction: 'Stake',
      status: 'Pending',
    },
    {
      date: '10/12/2024 16:46:47',
      order: '0x47685...4c8B',
      amount: '$0.01',
      transaction: 'Unstake',
      status: 'Pending',
    },
    {
      date: '10/12/2024 16:46:47',
      order: '0x47685...4c8B',
      amount: '0.01',
      transaction: 'Stake',
      status: 'Pending',
    },
  ];
  return (
    <div className="activity_table">
      <CommonTable fields={fields} tableTitle="Staking in progress">
        {list?.map((item: any, index: number) => (
          <tr key={index}>
            <td>{item?.date}</td>
            <td>
              <div>
                {item?.order}{' '}
                <button className="copyicon">
                  <CopyIcon />
                </button>
              </div>
            </td>
            <td>${item?.amount}</td>
            <td>{item?.transaction}</td>
            <td>{item?.status}</td>
          </tr>
        ))}
      </CommonTable>
      {/* <CustomPagination total={54} page={1}/> */}
    </div>
  );
};

export default StakingInProgressTable;
